import { useState, useEffect, useRef } from 'react'
import { useLocation, Link } from 'wouter'
import { trackEvent } from '@/lib/analytics'

const socialLinks = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/spoke.movie/',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61577517413587',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg>
    ),
  },
  {
    label: 'Substack',
    href: 'https://filmabeestudios.substack.com/',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/>
      </svg>
    ),
  },
]

const podcastLinks = [
  {
    label: 'Apple Podcasts',
    href: 'https://podcasts.apple.com/us/podcast/unseen-exposures/id6790598052',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M5.34 0A5.328 5.328 0 000 5.34v13.32A5.328 5.328 0 005.34 24h13.32A5.328 5.328 0 0024 18.66V5.34A5.328 5.328 0 0018.66 0zm7.952 4.08a7.77 7.77 0 017.77 7.77 7.77 7.77 0 01-7.77 7.77A7.77 7.77 0 015.52 11.85a7.77 7.77 0 017.77-7.77zm0 1.44a6.33 6.33 0 00-6.33 6.33 6.33 6.33 0 006.33 6.33 6.33 6.33 0 006.33-6.33 6.33 6.33 0 00-6.33-6.33zm0 2.28a1.61 1.61 0 011.61 1.61 1.61 1.61 0 01-1.61 1.61 1.61 1.61 0 01-1.61-1.61 1.61 1.61 0 011.61-1.61zm-3.45 3.71c.42-.74 1.04-1.32 1.8-1.66l.6 1.02c-.52.24-.96.64-1.24 1.14a2.62 2.62 0 00-.27 1.79l-1.18.2a3.9 3.9 0 01.29-2.49zm6.9 0a3.9 3.9 0 01.29 2.49l-1.18-.2a2.62 2.62 0 00-.27-1.79 2.62 2.62 0 00-1.24-1.14l.6-1.02c.76.34 1.38.92 1.8 1.66zm-3.45 1.54c.48 0 .87.39.87.87s-.39.87-.87.87a.87.87 0 01-.87-.87c0-.48.39-.87.87-.87zm0 1.74c.6 0 1.16.16 1.64.44l1.38 3.79-1.12.41-1.27-3.49a1.94 1.94 0 01-.63.11 1.94 1.94 0 01-.63-.11l-1.27 3.49-1.12-.41 1.38-3.79c.48-.28 1.04-.44 1.64-.44z"/>
      </svg>
    ),
  },
  {
    label: 'Spotify',
    href: 'https://open.spotify.com/show/033P2oUTXryGH5KR7gWRzP',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@UNSEENEXPOSURES',
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
]

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [isSocialOpen, setIsSocialOpen] = useState(false)
  const [isMobileSocialOpen, setIsMobileSocialOpen] = useState(false)
  const [isPodcastOpen, setIsPodcastOpen] = useState(false)
  const [isMobilePodcastOpen, setIsMobilePodcastOpen] = useState(false)
  const socialRef = useRef<HTMLDivElement>(null)
  const podcastRef = useRef<HTMLDivElement>(null)
  const [location] = useLocation()
  const isHome = location === '/'
  const isContact = location === '/get-in-touch'
  const isSupport = location === '/dosomething'
  const isResources = location === '/resources'
  const isBlog = location === '/blog'

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (socialRef.current && !socialRef.current.contains(e.target as Node)) {
        setIsSocialOpen(false)
      }
      if (podcastRef.current && !podcastRef.current.contains(e.target as Node)) {
        setIsPodcastOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const scrollTo = (id: string) => {
    if (!isHome) {
      window.location.href = `${import.meta.env.VITE_ROUTER_BASE ?? ""}#${id}`
      return
    }
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth' })
    setIsMobileMenuOpen(false)
  }

  const scrollNavItems = [
    { id: 'about', label: 'Home' },
  ]

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isScrolled ? 'bg-black/20 backdrop-blur-md border-b border-gray-800/30' : 'bg-transparent border-b border-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="flex items-center">
            <img
              src="/spoke-static/images/spoke-logo-white.png"
              alt="SPOKE"
              className="h-7"
              style={{ filter: 'none' }}
            />
          </button>

          {/* Desktop nav */}
          <div className="hidden lg:flex items-center gap-4 xl:gap-8">
            <div className="flex items-baseline gap-4 xl:gap-8">
              {scrollNavItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className={`transition-colors duration-300 font-medium text-base xl:text-lg whitespace-nowrap hover:text-red-500 ${isHome && item.id === 'about' ? 'text-red-500' : 'text-gray-200'}`}
                >
                  {item.label}
                </button>
              ))}
              {/* Tell Me More — hidden for now */}
              <Link
                href="/resources"
                className={`transition-colors duration-300 font-medium text-base xl:text-lg whitespace-nowrap hover:text-red-500 ${isResources ? 'text-red-500' : 'text-gray-200'}`}
              >
                Resources
              </Link>
              <Link
                href="/blog"
                className={`transition-colors duration-300 font-medium text-base xl:text-lg whitespace-nowrap hover:text-red-500 ${isBlog ? 'text-red-500' : 'text-gray-200'}`}
              >
                Blog
              </Link>

              {/* Podcast dropdown */}
              <div className="relative" ref={podcastRef}>
                <button
                  onClick={() => setIsPodcastOpen((o) => !o)}
                  className="flex items-center gap-1 transition-colors duration-300 font-medium text-base xl:text-lg whitespace-nowrap hover:text-red-500 text-gray-200"
                >
                  Podcast
                  <svg className={`w-4 h-4 transition-transform duration-200 ${isPodcastOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {isPodcastOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-black/90 backdrop-blur-md border border-white/10 rounded-lg py-2 shadow-xl">
                    {podcastLinks.map((p) => (
                      <a
                        key={p.label}
                        href={p.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setIsPodcastOpen(false)
                          trackEvent('social_click', { site: 'spoke', film: 'spoke', platform: p.label === 'YouTube' ? 'youtube' : p.label.toLowerCase().replace(' ', '_'), placement: 'desktop_navigation' })
                        }}
                        className="flex items-center gap-3 px-4 py-2 text-gray-200 hover:text-yellow-400 hover:bg-white/5 transition-colors duration-200 text-sm font-medium"
                      >
                        {p.icon}
                        {p.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>

              {/* Social dropdown */}
              <div className="relative" ref={socialRef}>
                <button
                  onClick={() => setIsSocialOpen((o) => !o)}
                  className="flex items-center gap-1 transition-colors duration-300 font-medium text-base xl:text-lg whitespace-nowrap hover:text-red-500 text-gray-200"
                >
                  Social
                  <svg
                    className={`w-4 h-4 transition-transform duration-200 ${isSocialOpen ? 'rotate-180' : ''}`}
                    fill="none" stroke="currentColor" viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>

                {isSocialOpen && (
                  <div className="absolute right-0 mt-2 w-44 bg-black/90 backdrop-blur-md border border-white/10 rounded-lg py-2 shadow-xl">
                    {socialLinks.map((s) => (
                      <a
                        key={s.label}
                        href={s.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => {
                          setIsSocialOpen(false)
                          if (s.label === 'Instagram' || s.label === 'Substack') {
                            trackEvent('social_click', { site: 'spoke', film: 'spoke', platform: s.label.toLowerCase(), placement: 'desktop_navigation' })
                          }
                        }}
                        className="flex items-center gap-3 px-4 py-2 text-gray-200 hover:text-yellow-400 hover:bg-white/5 transition-colors duration-200 text-sm font-medium"
                      >
                        {s.icon}
                        {s.label}
                      </a>
                    ))}
                  </div>
                )}
              </div>

              <a
                href="https://filmabee-studios.kit.com/spoke"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('newsletter_click', { site: 'spoke', film: 'spoke', placement: 'desktop_navigation', provider: 'kit' })}
                className="transition-colors duration-300 font-medium text-base xl:text-lg whitespace-nowrap hover:text-red-500 text-gray-200"
              >
                Subscribe
              </a>
              <Link
                href="/get-in-touch"
                className={`transition-colors duration-300 font-medium text-base xl:text-lg whitespace-nowrap hover:text-red-500 ${isContact ? 'text-red-500' : 'text-gray-200'}`}
              >
                Contact Us
              </Link>
            </div>

            {/* Support button */}
            <Link
              href="/dosomething"
              className={`transition-colors duration-300 font-montserrat font-black uppercase tracking-wider text-base xl:text-lg whitespace-nowrap px-4 py-1.5 border ${isSupport ? 'bg-yellow-400 text-black border-yellow-400' : 'border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black'}`}
            >
              DO SOMETHING
            </Link>
          </div>

          {/* Mobile hamburger */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-200 hover:text-red-500 p-2"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-black/80 backdrop-blur-lg rounded-lg mt-2">
              {scrollNavItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollTo(item.id)}
                  className={`block w-full text-left px-3 py-2 rounded-md text-base font-medium hover:bg-gray-800 transition-colors duration-300 hover:text-red-500 ${isHome && item.id === 'about' ? 'text-red-500' : 'text-gray-200'}`}
                >
                  {item.label}
                </button>
              ))}
              {/* Tell Me More — hidden for now */}
              <Link
                href="/resources"
                 onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-800 transition-colors duration-300 ${isResources ? 'text-red-500' : 'text-gray-200 hover:text-red-500'}`}
              >
                Resources
              </Link>
              <Link
                href="/blog"
                 onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-800 transition-colors duration-300 ${isBlog ? 'text-red-500' : 'text-gray-200 hover:text-red-500'}`}
              >
                Blog
              </Link>

              {/* Mobile podcast expandable */}
              <button
                onClick={() => setIsMobilePodcastOpen((o) => !o)}
                className="flex items-center justify-between w-full px-3 py-2 rounded-md text-base font-medium text-gray-200 hover:bg-gray-800 hover:text-red-500 transition-colors duration-300"
              >
                Podcast
                <svg className={`w-4 h-4 transition-transform duration-200 ${isMobilePodcastOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isMobilePodcastOpen && (
                <div className="pl-4 space-y-1">
                  {podcastLinks.map((p) => (
                    <a
                      key={p.label}
                      href={p.href}
                      target="_blank"
                      rel="noopener noreferrer"
                       onClick={() => {
                         setIsMobileMenuOpen(false)
                         trackEvent('social_click', { site: 'spoke', film: 'spoke', platform: p.label === 'YouTube' ? 'youtube' : p.label.toLowerCase().replace(' ', '_'), placement: 'mobile_navigation' })
                       }}
                      className="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-yellow-400 hover:bg-gray-800 transition-colors duration-300"
                    >
                      {p.icon}
                      {p.label}
                    </a>
                  ))}
                </div>
              )}

              {/* Mobile social expandable */}
              <button
                onClick={() => setIsMobileSocialOpen((o) => !o)}
                className="flex items-center justify-between w-full px-3 py-2 rounded-md text-base font-medium text-gray-200 hover:bg-gray-800 hover:text-red-500 transition-colors duration-300"
              >
                Social
                <svg
                  className={`w-4 h-4 transition-transform duration-200 ${isMobileSocialOpen ? 'rotate-180' : ''}`}
                  fill="none" stroke="currentColor" viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isMobileSocialOpen && (
                <div className="pl-4 space-y-1">
                  {socialLinks.map((s) => (
                    <a
                      key={s.label}
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                       onClick={() => {
                         setIsMobileMenuOpen(false)
                         if (s.label === 'Instagram' || s.label === 'Substack') {
                           trackEvent('social_click', { site: 'spoke', film: 'spoke', platform: s.label.toLowerCase(), placement: 'mobile_navigation' })
                         }
                       }}
                      className="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-yellow-400 hover:bg-gray-800 transition-colors duration-300"
                    >
                      {s.icon}
                      {s.label}
                    </a>
                  ))}
                </div>
              )}

              <a
                href="https://filmabee-studios.kit.com/spoke"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => {
                  setIsMobileMenuOpen(false)
                  trackEvent('newsletter_click', { site: 'spoke', film: 'spoke', placement: 'mobile_navigation', provider: 'kit' })
                }}
                className="block px-3 py-2 rounded-md text-base font-medium text-gray-200 hover:text-red-500 hover:bg-gray-800 transition-colors duration-300"
              >
                Subscribe
              </a>
              <Link
                href="/get-in-touch"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-medium hover:bg-gray-800 transition-colors duration-300 ${isContact ? 'text-red-500' : 'text-gray-200 hover:text-red-500'}`}
              >
                Contact Us
              </Link>
              <Link
                href="/dosomething"
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-3 py-2 rounded-md text-base font-montserrat font-black uppercase tracking-wider transition-colors duration-300 ${isSupport ? 'text-black bg-yellow-400' : 'text-yellow-400 hover:bg-gray-800'}`}
              >
                DO SOMETHING
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navigation
